<template>
    <div class="bg-white px-3 index" style="margin: 0 26px;margin-bottom: 0!important;">
        <div class="add_tits" ref="title">
            <el-form class="form-inlines" :inline="true">
                <el-form-item label="状态">
                    <el-select v-model="status" placeholder="请选择" size="small" filterable clearable>
                        <el-option v-for="item in  zt_options" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" size="small" @click="begin">搜索</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="ibox-content">
            <el-table :data="tableData" border v-loading="loading" :height="heights" ref="configurationTable">
                <el-table-column prop="create_user_text" label="申请医生" show-overflow-tooltip> </el-table-column>
                <el-table-column prop="addressee" label="收件人" show-overflow-tooltip> </el-table-column>
                <el-table-column prop="phone" label="联系电话" show-overflow-tooltip> </el-table-column>
                <el-table-column prop="create_user_text" label="所在地区" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{scope.row.province_text}}-{{scope.row.city_text}}-{{scope.row.area_text}}
                    </template>
                </el-table-column>
                <el-table-column prop="address" label="详细地址" show-overflow-tooltip> </el-table-column>
                <el-table-column prop="address" label="状态" width="100">
                    <template slot-scope="scope">
                        <div style="color:#E6A23C">{{scope.row.status | formData}}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="create_time" label="创建时间" show-overflow-tooltip width="180"> </el-table-column>
                <el-table-column label="操作" width="150">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">审核
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="u-f u-ac u-jsb ft_mr">
                <div></div>
                <div>
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="currentPage" :page-sizes="[15, 30, 50, 100]" :page-size="pagesize"
                        layout="total, sizes, prev, pager, next, jumper" :total="count">
                    </el-pagination>
                </div>
            </div>

        </div>
        <!--  -->
        <el-dialog title="审核设置" :visible.sync="dialogs" top="80px" center class="dialogs">
            <el-divider></el-divider>
            <div class="dialog-ibox-content">
                <el-form ref="form" :model="form" label-width="140px" :rules="rule" class="demo-ruleForm">
                    <el-form-item label="问题" prop="status">
                        <el-radio-group v-model="form.status" @change="form.textarea=''">
                            <el-radio label="1">确认</el-radio>
                            <el-radio label="2">拒绝</el-radio>
                            <el-radio label="3">等待</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="拒绝理由" v-if="form.status==2">
                        <el-input type="textarea" :rows="3" placeholder="请输入内容" v-model="form.textarea">
                        </el-input>
                    </el-form-item>
                </el-form>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submit('form')" size="small">确 定</el-button>
                <el-button @click="dialogs = false" size="small">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>


<script>
    import {
        mapState
    } from 'vuex'
    export default {
        data() {
            return {
                zt_options: [{
                    id: 1,
                    name: '确认'
                }, {
                    id: 2,
                    name: '拒绝'
                }, {
                    id: 3,
                    name: '等待'
                }],
                status: '',
                loading: false,
                tableData: [],
                currentPage: 1,
                pagesize: 15,
                count: 0,
                heights: null,

                // 
                eid: '',
                dialogs: false,
                form: {
                    status: '',
                    textarea: '',
                },
                rule: {
                    status: [{
                        required: true,
                        message: '状态不能为空'
                    }],

                }
            };
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            })
        },
        filters: {
            formData(val) {
                var value = ''
                if (val == 1) {
                    value = "确认"
                }
                if (val == 2) {
                    value = "拒绝"
                }
                if (val == 3) {
                    value = "等待"
                }
                return value
            }
        },
        mounted() {
            let that = this
            that.getHeight()
            that.begin()
        },
        methods: {
            // 获取高度
            getHeight() {
                let that = this;
                var title = that.$refs.title.offsetHeight
                that.heights = window.innerHeight - title - 200 + 'px'
                window.onresize = () => {
                    var title = that.$refs.title.offsetHeight
                    that.heights = window.innerHeight - title - 200 + 'px'
                }
            },
            begin() {
                let that = this
                that.currentPage = 1
                that.pagesize = 15
                that.search()
            },
            search() {
                let that = this
                that.loading = true
                axios
                    .post("/admin/DoctorQrcodeRecord/index", {
                        page: that.currentPage,
                        page_count: that.pagesize,
                        status: that.status,
                    }, {
                        token: true
                    })
                    .then(response => {
                        that.loading = false
                        that.tableData = response.data.data.list
                        that.count = response.data.data.totalCount
                    })
                    .catch(error => {})
            },
            handleSizeChange(val) {
                let that = this
                that.pagesize = val;
                that.search()
            },
            handleCurrentChange(val) {
                let that = this
                that.currentPage = val;
                that.search()
            },
            submit(formName) {
                let that = this
                that.$refs[formName].validate((valid) => {
                    if (valid) {
                        axios
                            .post(`/admin/DoctorQrcodeRecord/updateStatus`, {
                                id: that.eid,
                                status: that.form.status,
                                status_remark: that.form.textarea
                            }, {
                                token: true
                            })
                            .then(response => {
                                if (response.data.code == '200') {
                                    that.dialogs = false
                                    that.search()
                                    that.$message({
                                        message: '操作成功',
                                        type: 'success'
                                    });
                                } else {
                                    that.$message.error(response.data.message);
                                }
                            })
                            .catch(error => {})
                    } else {
                        that.$alert('信息遗漏未填')
                        return false;
                    }
                });
            },
            handleEdit(index, row) {
                let that = this
                that.dialogs = true
                that.eid = row.id
                that.clear()
                that.form.status = row.status.toString()
                that.form.textarea = row.status_remark

            },
            clear() {
                let that = this
                that.form.status = ''
                that.form.textarea = ''
            },


        },

    };
</script>


<style lang="scss" scoped>
 .index{
        border-radius: 6px;
        padding-bottom: 10px;
    }
</style>